import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, setApiKeyToObject, toPathString } from '../common.mjs';
import { BASE_PATH, BaseAPI } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const JobDescriptionSupportPublicControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @param {JobDescriptionSupportPublicControllerApiGetEmploymentContractTypesInUsedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmploymentContractTypesInUsed: ({ customerIdHash }, options = {}) => {
      assertParamExists("getEmploymentContractTypesInUsed", "customerIdHash", customerIdHash);
      const localVarPath = "/api-public/v2/recruiting/customers/{customerIdHash}/employment-contract-types-in-used".replace("{".concat("customerIdHash", "}"), encodeURIComponent(String(customerIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setApiKeyToObject(localVarHeaderParameter, "x-flex-aid", configuration);
      setApiKeyToObject(localVarHeaderParameter, "WS_AID", configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return __spreadProps(__spreadValues({}, localVarRequestOptions), {
        identifier: "getEmploymentContractTypesInUsed",
        url: toPathString(localVarUrlObj)
      });
    },
    /**
     * 
     * @summary 직무 조회 API
     * @param {JobDescriptionSupportPublicControllerApiGetJobRolesForPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJobRolesForPublic: ({ customerIdHash }, options = {}) => {
      assertParamExists("getJobRolesForPublic", "customerIdHash", customerIdHash);
      const localVarPath = "/api-public/v2/recruiting/customers/{customerIdHash}/job-roles".replace("{".concat("customerIdHash", "}"), encodeURIComponent(String(customerIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = __spreadValues(__spreadValues({ method: "GET" }, baseOptions), options);
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setApiKeyToObject(localVarHeaderParameter, "x-flex-aid", configuration);
      setApiKeyToObject(localVarHeaderParameter, "WS_AID", configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = __spreadValues(__spreadValues(__spreadValues({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
      return __spreadProps(__spreadValues({}, localVarRequestOptions), {
        identifier: "getJobRolesForPublic",
        url: toPathString(localVarUrlObj)
      });
    }
  };
};
const JobDescriptionSupportPublicControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = JobDescriptionSupportPublicControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @param {JobDescriptionSupportPublicControllerApiGetEmploymentContractTypesInUsedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmploymentContractTypesInUsed(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.getEmploymentContractTypesInUsed(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    },
    /**
     * 
     * @summary 직무 조회 API
     * @param {JobDescriptionSupportPublicControllerApiGetJobRolesForPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJobRolesForPublic(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.getJobRolesForPublic(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
const JobDescriptionSupportPublicControllerApiFactory = function(configuration, basePath, axios) {
  const localVarFp = JobDescriptionSupportPublicControllerApiFp(configuration);
  return {
    /**
     * 
     * @param {JobDescriptionSupportPublicControllerApiGetEmploymentContractTypesInUsedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmploymentContractTypesInUsed(requestParameters, options) {
      return localVarFp.getEmploymentContractTypesInUsed(requestParameters, options)(axios, basePath);
    },
    /**
     * 
     * @summary 직무 조회 API
     * @param {JobDescriptionSupportPublicControllerApiGetJobRolesForPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getJobRolesForPublic(requestParameters, options) {
      return localVarFp.getJobRolesForPublic(requestParameters, options)(axios, basePath);
    }
  };
};
class JobDescriptionSupportPublicControllerApi extends BaseAPI {
  /**
   * 
   * @param {JobDescriptionSupportPublicControllerApiGetEmploymentContractTypesInUsedRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobDescriptionSupportPublicControllerApi
   */
  getEmploymentContractTypesInUsed(requestParameters, options) {
    return JobDescriptionSupportPublicControllerApiFp(this.configuration).getEmploymentContractTypesInUsed(requestParameters, options)(this.axios, this.basePath);
  }
  /**
   * 
   * @summary 직무 조회 API
   * @param {JobDescriptionSupportPublicControllerApiGetJobRolesForPublicRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof JobDescriptionSupportPublicControllerApi
   */
  getJobRolesForPublic(requestParameters, options) {
    return JobDescriptionSupportPublicControllerApiFp(this.configuration).getJobRolesForPublic(requestParameters, options)(this.axios, this.basePath);
  }
}
const getEmploymentContractTypesInUsedRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: JobDescriptionSupportPublicControllerApiAxiosParamCreator().getEmploymentContractTypesInUsed,
  requestFn: JobDescriptionSupportPublicControllerApiFp().getEmploymentContractTypesInUsed
});
const getJobRolesForPublicRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: JobDescriptionSupportPublicControllerApiAxiosParamCreator().getJobRolesForPublic,
  requestFn: JobDescriptionSupportPublicControllerApiFp().getJobRolesForPublic
});

export { JobDescriptionSupportPublicControllerApi, JobDescriptionSupportPublicControllerApiAxiosParamCreator, JobDescriptionSupportPublicControllerApiFactory, JobDescriptionSupportPublicControllerApiFp, getEmploymentContractTypesInUsedRemote, getJobRolesForPublicRemote };
//# sourceMappingURL=job-description-support-public-controller-api.mjs.map
